/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesInvoiceStatus } from './WebApiModelsEnumerationTypesInvoiceStatus';
import {
    WebApiModelsEnumerationTypesInvoiceStatusFromJSON,
    WebApiModelsEnumerationTypesInvoiceStatusFromJSONTyped,
    WebApiModelsEnumerationTypesInvoiceStatusToJSON,
} from './WebApiModelsEnumerationTypesInvoiceStatus';

/**
 * An invoice OneFront has sent to the company, as shown on the company's own Payments page.
 * Deliberately excludes admin-only fields (price overrides, blob path).
 * @export
 * @interface WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto
 */
export interface WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto
     */
    invoiceNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesInvoiceStatus}
     * @memberof WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto
     */
    status?: WebApiModelsEnumerationTypesInvoiceStatus;
    /**
     * 
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto
     */
    hasPdf?: boolean;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDtoFromJSON(json: any): WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto {
    return WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'invoiceNumber': !exists(json, 'invoiceNumber') ? undefined : json['invoiceNumber'],
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesInvoiceStatusFromJSON(json['status']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'hasPdf': !exists(json, 'hasPdf') ? undefined : json['hasPdf'],
    };
}

export function WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDtoToJSON(value?: WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'invoiceNumber': value.invoiceNumber,
        'status': WebApiModelsEnumerationTypesInvoiceStatusToJSON(value.status),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'hasPdf': value.hasPdf,
    };
}

